<template>
  <div class="account-dropdown">
    <v-menu offset-y>
      <v-btn fab flat dark small slot="activator">
        <v-icon light>mdi-account-circle mdi-24px</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile class="cursor">
          <v-list-tile-title>
            <router-link :to="'cadastrar'"></router-link> Meus Dados
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile class="cursor">
          <v-list-tile-title @click="logout()"> Sair</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import AuthenticationService from '../../services/AuthenticationService';

export default {
  name: 'AccountDropdown',
  data: () => ({
    items: [
      { title: 'Meus Dados' },
      { title: 'Sair' },
    ],
  }),
  methods: {
    logout() {
      AuthenticationService.logout();
      this.$router.push({name: 'requerenteSignIn'});
      this.$store.dispatch('emptyApplications');
    },
  },
};
</script>

<style scoped lang="scss">
  .cursor{
    cursor:pointer;
  }
  .cursor:hover{
    background: #ccc;
  }
</style>
